import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { ServiceInventoryService, ServiceState } from '@brightside-web/desktop/data-access/service-inventory';
import { Observable, filter, map } from 'rxjs';
import { getRouteForKey } from '@brightside-web/desktop/data-access/core-services';

@Injectable({
  providedIn: 'root',
})
export class SurveyInfoViewGuard {
  private _serviceInventory: ServiceInventoryService = inject(ServiceInventoryService);
  private _router: Router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this._serviceInventory.getService('survey_emoney').pipe(
      filter((service) => !!service),
      map((service) => {
        if ([ServiceState.INITIAL].includes(service.state)) {
          return true;
        }
        this._router.navigate([getRouteForKey({key: 'survey_emoney' })]);
        return false;
      })
    );
  }
}
